import React from 'react'
import { Divider, Typography } from 'antd'
import Dashboard from '../../../components/Kanban-Count-Accuracy/Dashboard/Dashboard'

const KanbanCountAccuracyDashbaordPage = ({ userData }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Dashboard
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <Dashboard userData={userData} />
        </>
    )
}

export default KanbanCountAccuracyDashbaordPage